import { FC } from "react";
import { AppBar, Box, Divider, Toolbar, Typography } from "@mui/material";
import Logo from "./logo.svg?react";
import { User } from "../../components/user";
import { peekRuntimeConfig } from "../../runtimeConfig/runtime-config";
import { useThemeMode } from "../../theme";
import { ThemeSwitch } from "../../components/themeSwitch";

export const Topbar: FC = () => {
  const { mode, toggleTheme } = useThemeMode();
  const isDevOrTest = peekRuntimeConfig()?.PUBLIC_IS_TEST_ENV ?? false;

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        background: (theme) =>
          theme.palette.mode === "dark" ? "#1c2128" : theme.palette.primary.dark,
        borderBottom: (theme) =>
          theme.palette.mode === "dark"
            ? "1px solid rgba(255, 255, 255, 0.06)"
            : "none",
      }}
    >
      <Toolbar
        variant="regular"
        sx={{
          zIndex: 1,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "none"
              : "0px 2px 4px rgba(0, 0, 0, 0.3)",
        }}
      >
        <Logo height="64px" />
        <Box sx={{ flexGrow: 1, textAlign: "center" }}>
          <Typography variant="h5" color="MFT_OFF_WHITE">
            Compliance Hub
          </Typography>
          {isDevOrTest && (
            <Typography variant="h5" color="MFT_OFF_WHITE" sx={{ padding: 4 }}>
              🚧 Test environment 🚧
            </Typography>
          )}
        </Box>
        <ThemeSwitch checked={mode === "dark"} onChange={toggleTheme} />
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginX: 1, marginY: 2, borderColor: "#7f7f7f" }}
        />

        <User />
      </Toolbar>
    </AppBar>
  );
};
